import React, { useId } from 'react';

import {
  SegmentedControlSlide,
  SegmentedRadioControl,
  SegmentedControlGroup,
  SegmentedControlLabel,
  SegmentedControlContainer,
} from './SegmentedControl.styles';
import { SegmentedControlProps } from './types';

export const RawSegmentedControl = ({
  disabled = false,
  onChange,
  items = [],
  value,
}: SegmentedControlProps) => {
  const groupId = useId();
  const slidePosition = items.findIndex(item => item.id === value);

  if (!items.length) {
    return null;
  }

  return (
    <SegmentedControlContainer>
      <SegmentedControlGroup>
        {items.map(({ id, label, prefixIcon }, index) => (
          <div key={id}>
            <SegmentedRadioControl
              disabled={disabled}
              type="radio"
              id={`${groupId}-${index}`}
              name={groupId}
              value={label}
              checked={id === value}
              readOnly
            />
            <SegmentedControlLabel
              onClick={() => {
                onChange(id);
              }}
              htmlFor={`${groupId}-${index}`}
            >
              {prefixIcon && <span>{prefixIcon}</span>}
              <span>{label}</span>
              {/*
                SegmentedControlSlide placed inside SegmentedControlLabel to inherit the same width from the label, and index === 0 is a small hack that will render only one slide
               */}
              {value && index === 0 && (
                <SegmentedControlSlide position={slidePosition} />
              )}
            </SegmentedControlLabel>
          </div>
        ))}
      </SegmentedControlGroup>
    </SegmentedControlContainer>
  );
};
